import Typography from '@mui/material/Typography';

export default function ErrorContent({children,...props}) {
    return (                
        <Typography variant="body2" color="error" {...props}>{children}</Typography>    
    )
}